jQuery(document).ready(() => {
  jQuery('select').formSelect({
    isMultiple: false,
  });
  jQuery('.tooltipped').tooltip();
  // jQuery(document).ajaxComplete(function(event, xhr, settings) {
  jQuery(document).ajaxComplete(() => {
    jQuery('select').formSelect({
      isMultiple: false,
    });
    jQuery('.tooltipped').tooltip();
    // Open off canvas block in layout builder
    jQuery('.inline-block-create-button').click();
  });
});
